export default __webpack_public_path__ + "static/media/ABSLogo.91f0f240.png";